"use client";

import { Navbar } from "@/components/Navbar/NavBar";
import { Hero } from "@/features/marketing/hero/Hero";
import { HowItWorks } from "@/features/marketing/how-it-works/HowItWorks";
import { CashFlowInsight } from "@/features/marketing/cash-flow/CashFlowInsight";
import { WorkingsInsight } from "@/features/marketing/workings/WorkingsInsight";
import { ConfidenceInsight } from "@/features/marketing/confidence/ConfidenceInsight";
import FridaySms from "@/features/marketing/friday-sms/FridaySms";
import { TargetAudience } from "@/features/marketing/target-audience/TargetAudience";
import VatCycle from "@/features/marketing/vat-cycle/VatCycle";
import { FAQ } from "@/features/marketing/faq/FAQ";
import TrialBanner from "@/features/marketing/trial-banner/TrialBanner";
import { Footer } from "@/features/marketing/footer/Footer";
import { ScrollReveal } from "@/components/ui/PageTransition";

export default function WelcomePage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <ScrollReveal>
          <HowItWorks />
        </ScrollReveal>
        <ScrollReveal>
          <CashFlowInsight />
        </ScrollReveal>
        <ScrollReveal>
          <WorkingsInsight />
        </ScrollReveal>
        <ScrollReveal>
          <ConfidenceInsight />
        </ScrollReveal>
        <ScrollReveal>
          <FridaySms />
        </ScrollReveal>
        <ScrollReveal>
          <TargetAudience />
        </ScrollReveal>
        <ScrollReveal>
          <VatCycle />
        </ScrollReveal>
        <ScrollReveal>
          <FAQ />
        </ScrollReveal>
        <ScrollReveal>
          <TrialBanner />
        </ScrollReveal>
        <Footer />
      </main>
    </div>
  );
}
